import axios from 'axios'
import qs from 'querystring'
import {Toast} from 'cube-ui'
import store from '@/store'

let toastLoading;

/**
 * 节流函数
 * @param {*} fn
 * @param {*} wait
 * @param {*} scope
 */
const throttle = function (fn, wait, scope) {
	clearTimeout(throttle.timer)
	throttle.timer = setTimeout(function() {
        fn.apply(scope)
    }, wait)
}


// 创建axios实例
const instance = axios.create({
	baseURL: process.env.API_ROOT,
	withCredentials: true,
	// headers: {
	// 	post: {
	// 		'Content-Type': 'application/json; charset=utf-8'
	// 	},
	// 	'Access-Control-Allow-Origin': '*',
	// 	'Access-Control-Allow-Headers': "Origin, X-Requested-With, Content-Type, Accept",
	// 	'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS, HEAD'
	// },
	method: 'post',
	timeout: 90000,
	paramsSerializer: params => qs.stringify(params) // 序列化参数,
})

/**
 * 显示成功
 * @param {*} option
 */
const showToast = option => {
	toastLoading = Toast.$create(Object.assign(option, {
		time: 1000,
		type: 'txt'
		// mask: true,
		// maskClosable: false
	}))

	toastLoading.show()
}

// post
// instance.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'

/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
    config => {
			// 登录流程控制中，根据本地是否存在token判断用户的登录情况
			// 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
			// 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
			// 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
			const token = store.state.user.token,
						uid = store.state.user.uid;

			let params = config

			// 统一处理方式
			config.method = params && params.method || "post"

			// 自动添加 token 和 uid 到请求参数中
			if (config.method == "post") {
				// POST 请求：添加到 data 中
				const dataObj = config.data || {}
				
				// 特殊处理 FormData 类型（文件上传）
				if (dataObj instanceof FormData) {
					// FormData 类型，直接添加 token 和 uid
					if (token && uid) {
						dataObj.append('token', token)
						dataObj.append('uid', uid)
					}
					// 不序列化，保持 FormData 格式
					config.data = dataObj
				} else {
					// 普通对象，按原来的方式处理
					// 如果 data 已经是字符串，先解析（虽然通常不会发生）
					const data = typeof dataObj === 'string' ? {} : dataObj
					
					// 添加 token 和 uid（如果存在）
					if (token && uid) {
						data.token = token
						data.uid = uid
					}
					
					// 确保 data 是对象，然后序列化
					const stringifiedData = qs.stringify(data)
					
					config.data = stringifiedData

					// 调试日志：如果是 arouse 接口，打印最终 data
					if (config.url && config.url.includes('arouse')) {
						console.log('=== arouse POST 请求体（序列化后）===')
						console.log('data:', stringifiedData)
					}
				}
			} else {
				// GET 请求：添加到 params 中
				config.params = config.params || {}
				if (token && uid) {
					config.params.token = token
					config.params.uid = uid
				}
				
				// 调试日志：如果是 getOpenid 接口，打印详细信息
				if (config.url && config.url.includes('getOpenid')) {
					console.log('=== getOpenid GET 请求参数 ===')
					console.log('原始 params:', config.params)
					console.log('params 中的 code:', config.params.code)
					console.log('token:', token)
					console.log('uid:', uid)
				}
			}

			return config
    },
    error => Promise.error(error)
)

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 * @param {String} msg 错误消息
 * @param {Boolean} skipToast 是否跳过错误提示
 */
const errorHandle = (status, msg, skipToast = false) => {
	if (skipToast) {
		return // 跳过错误提示
	}
	
	let txt = ''

	switch (status) {
		case 404:
			txt = '找不到页面'
			break;
		case 429:
			txt = '请求过快，请1秒后发起请求'
			break;
		case 500:
			txt = '内部服务器错误'
			break;
		default:
			txt = msg
			break;
	}

	// 非，空提示才窗口
	!!txt && showToast({txt: txt})
}

// 响应拦截器
instance.interceptors.response.use(
	// 请求成功
	res => {
		const {data} = res

		// 验证码图片处理
		if (data instanceof ArrayBuffer) {
			return Promise.resolve('data:image/png;base64,' + btoa(new Uint8Array(data).reduce((data, byte) => data + String.fromCharCode(byte), '')))
		}

		// 处理不同的响应格式
		// 格式1: {status: 200, data: {...}}
		// 格式2: {code: 200, data: {...}}
		// 如果后端返回 code: 200，也视为成功（优先检查 code）
		if (data.code === 200) {
			console.log('=== 响应拦截器：检测到 code: 200，返回成功响应 ===')
			console.log('响应数据:', data)
			return Promise.resolve(data)
		}
		
		switch (data.status) {
			case 200:
				return Promise.resolve(data)
				break;
			// case 304:
			case 3001:
			case 3002:
				showToast({txt: '有密码，更安全哟！'})
				return Promise.resolve(data)
				break;
			case 10001:
			case 4002:
			case 4035:  // 订单尚未支付成功，不弹窗
			case 1001:  // wxjssdk 不提示错误信息
				return Promise.reject(data)
			default:
				!!data.msg && showToast({txt: data.msg})
				return Promise.reject(data)
				break;
		}
	},
	error =>  {
		const { response, config } = error
		if (response) {
			// 请求已发出，但是不在2xx的范围
			// 检查是否跳过错误提示
			const skipToast = config && config.skipErrorToast
			errorHandle(response.status, response.statusText, skipToast)
			return Promise.reject(response)
		} else {
			// 处理断网的情况
			// eg:请求超时或断网时，更新state的network状态
			// network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
			// 关于断网组件中的刷新重新获取数据，会在断网组件中说明
			if (!window.navigator.onLine) {
			//    store.commit('changeNetwork', false)
			} else {
					return Promise.reject(error)
			}
		}
	}
)

export default instance



// WEBPACK FOOTER //
// ./src/common/axios/fetch.js